<!-- Card component -->
<div class="h-full border print:border-0 border-gray-300 rounded bg-white shadow-lg print:shadow-none">
  <ng-content></ng-content>
</div>